import './bootstrap';
import setupScrollToTopButton from './03-components/scrollToTopButton';
import setupHeaderScrollBehavior from './03-components/headerScrollHandler';

document.addEventListener('DOMContentLoaded', () => {
    setupScrollToTopButton(); // Initialize scroll-to-top arrow behavior
    setupHeaderScrollBehavior(); // Initialize header scroll behavior
    // setupScrollListener((event) => {
    //     console.log('Scroll event:', event);
    // }, 150); // Example usage of scroll listener
});
